var _templateObject = _taggedTemplateLiteralLoose(['\n  position: relative;\n  display: inline-block;\n  width: 35px;\n  height: 22px;\n  margin: 0 10px;\n  input {\n    display: none;\n    &:checked + span {\n      background-color: ', ';\n    }\n    &:focus + span {\n      box-shadow: 0 0 1px ', ';\n    }\n\n    &:checked + span:before {\n      transform: translateX(16px);\n    }\n  }\n\n  span {\n    position: absolute;\n    border-radius: 34px;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: ', ';\n    transition: .4s;\n\n    &:before {\n      border-radius: 50%;\n      position: absolute;\n      content: \'\';\n      height: 22px;\n      width: 22px;\n      background-color: white;\n      transition: .4s;\n      border: ', ';\n    }\n  }\n'], ['\n  position: relative;\n  display: inline-block;\n  width: 35px;\n  height: 22px;\n  margin: 0 10px;\n  input {\n    display: none;\n    &:checked + span {\n      background-color: ', ';\n    }\n    &:focus + span {\n      box-shadow: 0 0 1px ', ';\n    }\n\n    &:checked + span:before {\n      transform: translateX(16px);\n    }\n  }\n\n  span {\n    position: absolute;\n    border-radius: 34px;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: ', ';\n    transition: .4s;\n\n    &:before {\n      border-radius: 50%;\n      position: absolute;\n      content: \'\';\n      height: 22px;\n      width: 22px;\n      background-color: white;\n      transition: .4s;\n      border: ', ';\n    }\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  align-content: center;\n  font-weight: bold;\n  white-space: nowrap;\n  align-items: center;\n  cursor: pointer;\n'], ['\n  display: flex;\n  align-content: center;\n  font-weight: bold;\n  white-space: nowrap;\n  align-items: center;\n  cursor: pointer;\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Theme from '../../Theme';

export var ToggleIconWrapper = styled.div(_templateObject, Theme.colors.lightBlue, Theme.colors.lightBlue, Theme.colors.darkgrey, function (props) {
  return '1px solid ' + (props.checked ? Theme.colors.lightBlue : Theme.colors.darkgrey);
});

var Label = styled.label(_templateObject2);

var Toggle = function Toggle(_ref) {
  var checked = _ref.checked,
      onChange = _ref.onChange,
      labelRight = _ref.labelRight,
      labelLeft = _ref.labelLeft;
  return React.createElement(
    Label,
    null,
    labelLeft,
    React.createElement(
      ToggleIconWrapper,
      { checked: checked },
      React.createElement('input', { type: 'checkbox', checked: checked, onChange: onChange }),
      React.createElement('span', null)
    ),
    labelRight
  );
};

Toggle.displayName = 'Toggle';
Toggle.propTypes = process.env.NODE_ENV !== "production" ? {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  labelRight: PropTypes.string,
  labelLeft: PropTypes.string
} : {};

export default Toggle;